import styled, { CSSObject } from '@emotion/styled'
import { Medium } from 'shop/components/common'
import {
  IoLocationOutline as PinIcon,
  IoReceiptOutline as ReceiptIcon,
  IoTimeOutline as ClockIcon,
  IoHomeOutline as HomeIcon
} from 'react-icons/io5'
import GenericBreakdownItem from 'shop/components/GenericBreakdownItem/GenericBreakdownItem'
import { createAddressString } from 'shop/utils/address'
import { BaseAddress, Fulfillment } from 'shop/types/cart'
import { getFulfillmentFlags } from 'shop/utils'

type Props = {
  fulfillment: Fulfillment
  deliveryAddress: BaseAddress | null
  storeAddress: BaseAddress
  onChangeButtonClick?: () => void
}

const FulfillmentBreakdownItem = ({
  fulfillment,
  deliveryAddress,
  storeAddress,
  onChangeButtonClick
}: Props) => {
  const { type: fulfillmentType, tableNumber } = fulfillment
  const { isOrderAtTable } = getFulfillmentFlags(fulfillmentType)

  const fulfillmentDetails = {
    DELIVERY: {
      timeIcon: ClockIcon,
      addressIcon: HomeIcon,
      title: 'Delivery Details',
      prefix: 'Delivering to ',
      text:
        (deliveryAddress &&
          createAddressString(deliveryAddress, { withCommas: true })) ||
        ''
    },
    PICKUP: {
      timeIcon: ClockIcon,
      addressIcon: PinIcon,
      title: 'Pickup Details',
      prefix: 'Pickup from ',
      text: `${createAddressString(storeAddress, {
        withCommas: true
      })}`
    },
    ORDER_AT_TABLE: {
      timeIcon: undefined,
      addressIcon: ReceiptIcon,
      title: 'Table Order Details',
      prefix: 'Table ',
      text: tableNumber || ''
    }
  }

  const CollapsedOATDetails = () => (
    <span>{`${fulfillmentDetails[fulfillmentType].prefix}${fulfillmentDetails[fulfillmentType].text}`}</span>
  )

  const CollapsedDetails = () => (
    <>
      <Medium>{fulfillmentDetails[fulfillmentType].prefix}</Medium>
      <span>{fulfillmentDetails[fulfillmentType].text}</span>
    </>
  )
  return (
    <GenericBreakdownItem
      label={
        <CollapsedDetailsContainer>
          {isOrderAtTable ? <CollapsedOATDetails /> : <CollapsedDetails />}
        </CollapsedDetailsContainer>
      }
      maxWidth={'100%'}
      withEllipsis={false}
      withLineBreak={false}
      LeftIcon={fulfillmentDetails[fulfillmentType].addressIcon}
      padding={'0'}
      {...(onChangeButtonClick && { onChangeButtonClick })}
    />
  )
}

const CollapsedDetailsContainer = styled.div(
  (): CSSObject => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',

    '& i': {
      fontSize: '12px'
    }
  })
)

export default FulfillmentBreakdownItem
